import * as actionTypes from './actionsTypes';

export const setname = (payload) => {
    return {
        type: actionTypes.SETNAME,
        value: payload
    }
}